module.exports = __webpack_public_path__ + "img/app-logs.965a5b85.png";